import { transitionEvent } from './whichTransitionEvent.js';

(function( $ ) {
  // TODO: Remove jQuery dependence
  //#https://stackoverflow.com/questions/5396119/using-jquery-delay-with-css
  $.fn.extend({
    qcss: function(css) {
       return $(this).queue(function(next) {
          $(this).css(css);
          next();
       });
    }
  });

  $.fn.collapse = function( /*options*/ ) {

    // Extend our default options with those provided.
    // Note that the first argument to extend is an empty
    // object – this is to keep from overriding our "defaults" object.
    // let settings = $.extend({}, $.fn.collapse.defaults, options);

    // Iterate and reformat each matched element.
    return this.each(function() {
      let open = true;
      let transitioning = false;
      let fullHeight;
      const $target = $($(this).data('target')) || $($(this).attr('href'));

      if (open === false) {
        $target.css('display', 'none');
      }

      $(this).on('click', function() {
        fullHeight = (!transitioning) ? $target.outerHeight() : fullHeight;
        let initialHeight = (open === false) ? 0 : fullHeight;
        let finalHeight = (open === false) ? fullHeight : 0;

        // Transition State
        transitioning = true
        $target.qcss({display: ''}).qcss({height: initialHeight}).qcss({height: finalHeight})

        // End State
        $target.one(transitionEvent, function() { // Checking for end of transition
          $target.css('height', ''); // Remove height at end
          if (open === false) {
            $target.css('display', 'none');
          }

          transitioning = false;
        });

        open = !open;
      });
    });
  }

  $('.btn-collapse').collapse();
})( jQuery )